import { gql } from "@apollo/client";

export const SESSION_EXPIRY = gql`
  query {
    sessionExpiresSeconds
  }
`;
